export default (value, { data }, values) => value.toString() === (values[data] == null ? '' : values[data]).toString();



// WEBPACK FOOTER //
// ./src/utils/validate/methods/confirm.js